import { useState, useEffect } from 'react';
import * as React from 'react';

//React Router
import { Navigate, useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom' //useParams to get the ref transmitted in the url

import dayjs from 'dayjs';

//created components
import HeaderStep from "../../../commons/headerstep/HeaderStep.jsx";
import BannerMoutchicLoisirs from "../../../commons/bannerMoutchicLoisirs/BannerMoutchicLoisirs.jsx";


//MUI Components
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
//selectors for redux :
import { useSelector, useDispatch } from "react-redux";

//Utils
import { checkLogin } from '../../../utils/check-login.js'
import prepaMail from "../../../utils/prepa-mail.js" //params : fullContrat 
import calculDuree from '../../../utils/calcul_duree.js' //we import this method because there is a bug to store the duree in Redux (infinite loop)

//import Fetch API functions
import { getArticles, getUnpaidContrats, getAllTarifs } from '../../../database/fetchApi.js'

// API fetch
import axios from "axios";
import { baseURL, cloudRunBaseURL } from '../../../config/api-config.js';


function ListUnpaid() { // component to manage the first step of shopping : choosing place and time

    const navigate = useNavigate();
    const [articles, setArticles] = useState([]);
    const [contrats, setContrats] = useState([]);
    const [spotFilter, setSpotFilter] = useState(0);
    const [contratId, setContratId] = useState(0);
    const [currentContrat, setCurrentContrat] = useState();
    const [tarifs, setTarifs] = useState([]);

    //const dureeObject = calculDuree(period); //get object with quantity for every durations (demis,jour, semaine...)

    const [open, setOpen] = React.useState(false);
    const handleOpen = (id) => {
        setOpen(true);
        setContratId(id);
        setCurrentContrat(contrats.filter((contrat) => contrat.id_contrat === id)[0]);
    };

    const handleClose = () => setOpen(false);


    useEffect(() => { //change opening hours when spot change (idspot as dependency)

        if (checkLogin() === false) {
            navigate("/manager/login/listunpaid");
        }; // if no login, no token, go to login page

        async function initArticles() { //we add this inner function to manage asynchrone
            let allArticles = await getArticles();
            setArticles([].concat(allArticles))
        } //end of async function
        initArticles(); //call the inner asnchrone function

        async function initContrats() { //we add this inner function to manage asynchrone
            let allContrats = await getUnpaidContrats();
            //keep only the paid contrats
            setContrats([].concat(allContrats));

        } //end of async function
        initContrats(); //call the inner asnchrone function

        async function initTarifs() { //we add this inner function to manage asynchrone
            let allTarifs = await getAllTarifs();
            setTarifs(allTarifs)
        } //end of async function
        initTarifs(); //call the inner asnchrone function 

    }, [])

    /*  useEffect(() => { //get current contrat by click on table line
 
         setCurrentContrat(contrats.filter((contrat) => contrat.id_contrat === contratId)[0]);
         console.log(currentContrat);
     }, [contratId]) */


    contrats && contrats.sort((c1, c2) => chrono(c1, c2));
    console.log(contrats);
    //// filter the contrats ifa filter is spot is chosen, or keep all contrats
    let filteredContrats = spotFilter === 0 ? contrats : contrats.filter((contrat) => contrat.spot_id === spotFilter);


    function chrono(contrat1, contrat2) {
        return contrat1.id_contrat > contrat2.id_contrat ? 1 : -1;
    }

    function prepDate(date1, date2) {
        return dayjs(date1).format("DD/MM") + "-" + dayjs(date2).format("DD/MM");
    }

    /* function getQteArticles(articles) {
        let qte = 0;
        articles.forEach((article) => { qte += article.qte })
        return qte;
    } */

    function getPaiementInfos(contrat) {
        let infos = "";
        if (contrat.Paiements.length === 0) {
            infos = "Aucun";
        }
        else {
            contrat.Paiements.forEach((paiement, index) => {

                infos += index > 0 ? ", " : "";
                infos += paiement.Status;

            })
        }
        return infos;

    }

    function getSpotInfos(contrat) {

        if (contrat.livraison === true) {
            return (["Livraison:", contrat.adresse_livraison]);
        }
        else {
            return ([contrat.Spot.nom_spot, contrat.Spot.adresse_spot]);
        }
    }

    function getDetailsArticles(article) {
        let details = "";
        details += String(article.qte) + " x  ";
        let typeArticle = articles.find((art) => art.id_article === article.article_id).type;
        details += typeArticle;
        return details
    }

    function getTaillesArticles(article) {
        let tailles = "";
        article.taille.forEach((taille, index) => {
            if (taille !== "0") {
                tailles += article.prenom[index] + " : " + taille + "cm  / "
            }
        })
        return tailles
    }

    function validUnpaidContract(currentContrat) {
        console.log(currentContrat);

        axios.put(`${baseURL}/contrat/${currentContrat.id_contrat}`, {
            solde: 0,
            paye: 1
        })
            .then((response) => {
                if (response.status === 200) { //isnertion OK
                    // mettre le contrat dans le global state pour la step6

                    //// -- remplir caisee
                    fillCaisse(response.data.data); //remplir les infos de caisse
                    sendMail(response.data.data);
                }
                else { //insertion problème
                    return response.status
                }
            })
            .catch(error => {
                return error
            })
    }

    function fillCaisse(fullContrat) {

        axios.post(`${baseURL}/caisse`, {
            contrat_id: fullContrat.id_contrat,
            ref_contrat: fullContrat.ref_contrat,
            type_paiement: 1,
            montant: fullContrat.total,
            date_paiement: fullContrat.date_crea
        })
            .then((response) => {
                if (response.status === 201) { //isnertion OK
                    console.log(response.data)

                }
                else { //insertion problème
                    return response.status
                }
            })
            .catch(error => {
                return error
            })
    }


    function sendMail(fullContrat) {
        let body = {
            to: fullContrat.Client.email,
            bcc: "sylvainboufflers2@gmail.com,manuel.vivion@gmail.com",
            subject: "[Reservation vélos] - contrat location " + fullContrat.ref_contrat,
            html: prepaMail(fullContrat, articles, calculDuree([[fullContrat.date1, fullContrat.date2], [fullContrat.h1, fullContrat.h2]]), tarifs)
        };

        axios.post(`${baseURL}/mailing/mail-confirm`, body)
            .then((response) => {
                setOpen(false) // --> fermer modal 

                if (response.status === 200) { //isnertion OK
                    //setFail(false); //to not trigger alert message
                    console.log("mail ok");
                }
                else { //insertion problème
                    //setFail(true); //to trigger alert message
                    console.log("mail pas ok");

                }
            })
            .catch(error => {
                setOpen(false) // --> fermer modal 
                // setFail(true); //to trigger alert message
                console.log("mail pas ok");

            })
    }

    return (
        <main>
            <BannerMoutchicLoisirs title={"Manager : Outil de réservation de vélos"} />
            <HeaderStep step={""} title={"Liste des contrats non payés"} custom={""} />


            <div className="list-contrat">
                <div className="list-contrat-spot-filter">
                    <h3>Tri par point de location : </h3>
                    <div className="list-contrat-spot-filter-boutons">
                        <p onClick={_ => setSpotFilter(0)}>Tous</p>
                        <p onClick={_ => setSpotFilter(1)}>Moutchic plage</p>
                        <p onClick={_ => setSpotFilter(2)}>Atelier Moutchic</p>
                        <p onClick={_ => setSpotFilter(3)}>Goelia, Marina Talaris</p>
                        <p onClick={_ => setSpotFilter(4)}>Le Tedey</p>
                        <p onClick={_ => setSpotFilter(5)}>Bernos</p>
                        <p onClick={_ => setSpotFilter(99)}>Livraison</p>
                    </div>
                </div>

                {contrats.length < 1 ?
                    <CircularProgress />
                    :
                    <Table className="list-contrat-tableau">
                        <TableHead>
                            <TableRow className="list-contrat-tableau-head">
                                <TableCell>id</TableCell>
                                <TableCell align="right">ref</TableCell>
                                <TableCell align="right">date créa.</TableCell>
                                <TableCell align="right">dates</TableCell>
                                <TableCell align="right">Client</TableCell>
                                <TableCell align="right">Tarif</TableCell>
                                <TableCell align="right">paiement</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                filteredContrats.map((contrat) => (
                                    <TableRow
                                        className="list-contrat-tableau-ligne"
                                        key={contrat.id_contrat}
                                        onClick={_ => (handleOpen(contrat.id_contrat))}
                                    >
                                        <TableCell component="th" scope="row" className={"list-contrat-tableau-ligne-spot"}>
                                            {contrat.id_contrat}
                                        </TableCell>
                                        <TableCell align="right">{contrat.ref_contrat}</TableCell>
                                        <TableCell align="right">{contrat.date_crea}</TableCell>
                                        <TableCell align="right">{prepDate(contrat.date1, contrat.date2)}</TableCell>
                                        <TableCell align="right">{contrat.Client.nom + " " + contrat.Client.prenom}</TableCell>
                                        <TableCell align="right">{contrat.total + ",00€"}</TableCell>
                                        <TableCell align="right">{getPaiementInfos(contrat)}</TableCell>
                                    </TableRow>
                                ))
                            }

                        </TableBody>
                    </Table>
                }

            </div>

            {currentContrat &&
                <Modal
                    open={open}
                    onClose={handleClose}
                >
                    <div className="modal-contrat">
                        <div className="modal-contrat-top">
                            <span onClick={_ => setOpen(false)}><CloseIcon /></span>
                            <h4>{"Contrat : " + currentContrat.ref_contrat}</h4>
                            <div className="modal-contrat-top-dates">
                                <p>{dayjs(currentContrat.date1).format("DD/MM/YY") + " " + currentContrat.h1 + "h00"}</p>
                                <div className="modal-contrat-top-dates-lien"></div>
                                <p>{dayjs(currentContrat.date2).format("DD/MM/YY") + " " + currentContrat.h2 + "h00"}</p>
                            </div>

                        </div>
                        <div className="modal-contrat-middle">
                            <div className="modal-contrat-middle-spot">
                                <h5>Point de location :</h5>
                                <p>{getSpotInfos(currentContrat)[0]}</p>
                                <p>{getSpotInfos(currentContrat)[1]}</p>
                            </div>
                            <div className="modal-contrat-middle-client">
                                <h5>Client :</h5>
                                <p>{currentContrat.Client.prenom + " " + currentContrat.Client.nom}</p>
                                <p>{currentContrat.Client.tel}</p>
                                <p>{currentContrat.Client.email}</p>
                            </div>
                        </div>
                        <div className="modal-contrat-bottom">
                            <p>{"Réservation faite le :" + dayjs(currentContrat.date_crea).format("DD/MM/YYYY")}</p>
                            <h5>{"Montant total de la résa : " + currentContrat.total + ",00€"}</h5>
                            <div className="modal-contrat-bottom-articles">
                                <h4>Liste des articles : </h4>
                                {
                                    currentContrat.ContratArticles.map((article) => (
                                        <div key={article.id} className="modal-contrat-bottom-articles-item">
                                            <p>{getDetailsArticles(article)}</p>
                                            <p>{getTaillesArticles(article)}</p>
                                        </div>
                                    ))
                                }

                            </div>

                            {currentContrat.commentaire.length > 2 ?
                                <div className="modal-contrat-bottom-commentaire">
                                    <h4>Commentaire : </h4>
                                    <p>{currentContrat.commentaire}</p>
                                </div>
                                : null}

                        </div>
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={_ => validUnpaidContract(currentContrat)}>
                            Valider ce contrat
                        </Button>
                    </div>
                </Modal>
            }

        </main>
    )
}




export default ListUnpaid